<template>
    <v-container fluid class="pa-6">
        <div class="d-flex align-center mb-2">
            <v-icon icon="mdi-image-check-outline" size="28" class="mr-3" />
            <div>
                <h2 class="text-h5 font-weight-bold mb-1">이미지 제작 가이드</h2>
                <div class="text-body-2 text-grey">
                    관리자에 등록하는 이미지의 규격입니다. 업로드 화면의 안내 문구도 이 값을 그대로 씁니다.
                </div>
            </div>
        </div>

        <v-alert type="info" variant="tonal" density="comfortable" class="mb-6">
            <div class="text-body-2">
                크기는 <strong>Figma 디자인 실측값</strong>입니다. 비율이 다른 이미지를 넣으면 화면에서 잘립니다.
                업로드 자체는 막지 않으니, 등록 후 실제 화면을 꼭 확인하세요.
            </div>
        </v-alert>

        <v-card v-for="(group, service) in grouped" :key="service" class="mb-6" variant="outlined">
            <v-card-title class="text-subtitle-1 font-weight-bold">{{ service }}</v-card-title>
            <v-divider />
            <v-table density="comfortable">
                <thead>
                    <tr>
                        <th style="width: 180px">항목</th>
                        <th style="width: 150px">권장 크기</th>
                        <th style="width: 100px">비율</th>
                        <th style="width: 150px">2배수</th>
                        <th>등록 위치 / 참고</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="row in group" :key="row.key">
                        <td class="font-weight-medium">{{ row.label }}</td>
                        <td>
                            <span class="font-weight-bold">{{ row.displayWidth }} × {{ row.displayHeight }}</span>
                            <span class="text-caption text-grey ml-1">px</span>
                        </td>
                        <td>{{ ratioText(row) }}</td>
                        <td class="text-grey">{{ retinaText(row) || '—' }}</td>
                        <td>
                            <div class="text-body-2">{{ row.where }}</div>
                            <div v-if="row.note" class="text-caption text-warning mt-1">{{ row.note }}</div>
                            <div v-if="row.safeArea" class="text-caption text-grey mt-1">{{ row.safeArea }}</div>
                        </td>
                    </tr>
                </tbody>
            </v-table>
        </v-card>

        <v-card variant="outlined" class="mb-6">
            <v-card-title class="text-subtitle-1 font-weight-bold">공통 사항</v-card-title>
            <v-divider />
            <v-card-text>
                <div class="mb-2">
                    <strong>파일 형식</strong> · {{ formats.join(' , ') }}
                </div>
                <div class="mb-2">
                    <strong>업로드 한도</strong> · {{ maxUploadMb }}MB
                    <span class="text-caption text-grey ml-2">(서버 설정값. 권장 용량은 항목별 표를 따르세요)</span>
                </div>
                <div>
                    <strong>2배수 제작</strong> · 고해상도 화면에서 흐려 보이지 않도록 표에 적힌 2배 크기로 만들고,
                    저장할 때 용량을 줄이는 것을 권장합니다.
                </div>
            </v-card-text>
        </v-card>

        <v-alert type="warning" variant="tonal" density="comfortable">
            <div class="text-body-2">
                <strong>확정 전 항목</strong> — 권장 용량과 2배수 제작은 운영 기준이 정해지지 않아
                초안으로 넣어 둔 값입니다. 확정되면
                <code>src/constants/imageSpecs.js</code> 를 고치면 이 페이지와 업로드 화면에 함께 반영됩니다.
            </div>
        </v-alert>
    </v-container>
</template>

<script>
import { IMAGE_SPECS, MAX_UPLOAD_MB, UPLOAD_FORMATS, ratioText, retinaText } from '@/constants/imageSpecs.js'

export default {
    name: 'ImageGuidePage',
    data() {
        return {
            formats: UPLOAD_FORMATS,
            maxUploadMb: MAX_UPLOAD_MB,
        }
    },
    computed: {
        grouped() {
            return Object.entries(IMAGE_SPECS).reduce((acc, [key, spec]) => {
                acc[spec.service] = acc[spec.service] || []
                acc[spec.service].push({ key, ...spec })
                return acc
            }, {})
        },
    },
    methods: {
        ratioText,
        retinaText,
    },
}
</script>
